export default "__VITE_PUBLIC_ASSET__810a9782__"